export const BUYCOFFEE_PROFILE = "https://buycoffee.to/ziolo.eu";

export const SUPPORT_SIZES = [
  { size: "small", pln: 5 },
  { size: "medium", pln: 10 },
  { size: "large", pln: 20 },
] as const;

export type SupportSize = (typeof SUPPORT_SIZES)[number]["size"];

export function supportHref(size: SupportSize): string {
  return `${BUYCOFFEE_PROFILE}?coffeeSize=${size}`;
}
